import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ChatMessagesQuery } from "../graphql/queries";
import type {
  ChatMessagesQueryType,
  ChatMessagesQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useChatMessagesQuery = (
  options?: QueryHookOptions<
    ChatMessagesQueryType,
    ChatMessagesQueryVariablesType
  >
) => {
  return useQuery<ChatMessagesQueryType, ChatMessagesQueryVariablesType>(
    ChatMessagesQuery,
    options
  );
};
